'use client'

import { FC } from 'react'
import { Wrapper } from './styled'
import { COLORS } from '@/constants'
import CircularProgress from "@mui/material/CircularProgress";

type LoaderProps = {
  isSmall?: boolean
}

export const Loader: FC<LoaderProps> = ({
  isSmall
}) => {
  return (
    <Wrapper sx={{
      padding: isSmall ? '10px 0' : '80px 0'
    }}>
      <CircularProgress size={isSmall ? 26 : 40} sx={{ color: COLORS.orange }} />
    </Wrapper>
  )
}
